<ng-container [ngSwitch]="id || tyre?.tyre_season?.id">
  <wchfs-icon *ngSwitchCase="'summer'" svgIcon="pso-legacy:season-summer"></wchfs-icon>
  <wchfs-icon *ngSwitchCase="'winter'" svgIcon="pso-legacy:season-winter"></wchfs-icon>
  <wchfs-icon *ngSwitchCase="'yearly'" svgIcon="pso-legacy:season-yearly"></wchfs-icon>
  <ng-container *ngSwitchDefault>-</ng-container>
</ng-container>
